module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row text-center holder"
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n    Loading\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8f49472"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/loading.vue
// module id = 56
// module chunks = 0